var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "viq-msg-loading" }, [
      _c("div", { staticClass: "viq-msg-loading__dots" }, [
        _c("span", { staticClass: "viq-msg-loading__dot" }),
        _vm._v(" "),
        _c("span", { staticClass: "viq-msg-loading__dot" }),
        _vm._v(" "),
        _c("span", { staticClass: "viq-msg-loading__dot" }),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "viq-msg-loading__text" }, [
        _vm._v("Generating answer…"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }